var _defs, _path, _ellipse, _ellipse2, _path2, _path3, _path4, _path5, _path6, _path7, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _path15, _path16, _ellipse11, _ellipse12, _ellipse13, _ellipse14, _ellipse15, _ellipse16, _ellipse17, _ellipse18, _ellipse19, _ellipse20, _circle, _path17, _path18, _ellipse21, _ellipse22, _ellipse23, _ellipse24, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _circle2, _path30, _path31, _ellipse25, _ellipse26, _ellipse27, _ellipse28, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlienNotFound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 498.84 464.11",
    width: 406,
    height: 306,
    className: "illustration",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 289.66,
    y1: 496.98,
    x2: 281.83,
    y2: 36.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 329.35,
    y1: 113.02,
    x2: 327.58,
    y2: 129.23,
    gradientTransform: "translate(-59.51 103.47) rotate(-13.63)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#010101",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#010101"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 354.34,
    y1: 75.81,
    x2: 254.27,
    y2: 103.28,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 287.04,
    y1: 90.43,
    x2: 286.55,
    y2: 162,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 303.54,
    y1: 98.67,
    x2: 260,
    y2: 108.21,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 291.62,
    y1: 90.71,
    x2: 287.39,
    y2: 94.85,
    gradientTransform: "translate(98.52 -141.81) rotate(33.14)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 301.88,
    y1: 90.77,
    x2: 300.2,
    y2: 94.99,
    gradientTransform: "translate(215.5 -208.48) rotate(56.86)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 290.55,
    y1: 118.05,
    x2: 293.8,
    y2: 69.9,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 293.18,
    y1: 104.12,
    x2: 297.42,
    y2: 104.12,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 349.02,
    y1: 78.53,
    x2: 259.01,
    y2: 103.24,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 288.52,
    y1: 86.25,
    x2: 289.83,
    y2: 201.48,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 262.05,
    y1: 67.58,
    x2: 260.49,
    y2: 81.87,
    gradientTransform: "translate(236.04 -145.86) rotate(76.37)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 376.61,
    y1: 89.89,
    x2: 375.05,
    y2: 104.19,
    gradientTransform: "translate(347.43 -263.12) rotate(76.37)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 276.62,
    y1: 147.72,
    x2: 309.42,
    y2: 77.71,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 282.93,
    y1: 39.93,
    x2: 281.32,
    y2: 54.67,
    gradientTransform: "translate(-49.55 132.04) rotate(-13.63)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 369.52,
    y1: 75.81,
    x2: 367.91,
    y2: 90.55,
    gradientTransform: "translate(326.39 -269.85) rotate(76.37)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 330.44,
    y1: 50.49,
    x2: 328.83,
    y2: 65.23,
    gradientTransform: "translate(-49.58 131.08) rotate(-13.63)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 240.27,
    y1: 54.04,
    x2: 238.49,
    y2: 70.25,
    gradientTransform: "translate(204.52 -130.07) rotate(76.37)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 402.72,
    y1: 87.32,
    x2: 400.95,
    y2: 103.53,
    gradientTransform: "translate(364.39 -295.13) rotate(76.37)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 294.61,
    y1: 231.63,
    x2: 270.15,
    y2: 236.99,
    gradientTransform: "translate(-37.73 79.56) rotate(-8.7)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 287.91,
    y1: 227.12,
    x2: 285.54,
    y2: 229.45,
    gradientTransform: "translate(165.49 -85.14) rotate(33.14)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 293.67,
    y1: 227.15,
    x2: 292.73,
    y2: 229.52,
    gradientTransform: "translate(318.42 -108.53) rotate(56.86)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 287.31,
    y1: 242.46,
    x2: 289.14,
    y2: 215.45,
    gradientTransform: "translate(-37.73 79.56) rotate(-8.7)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 288.79,
    y1: 234.64,
    x2: 291.17,
    y2: 234.64,
    gradientTransform: "translate(-37.73 79.56) rotate(-8.7)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 277.72,
    y1: 254.3,
    x2: 297.53,
    y2: 254.3,
    gradientTransform: "translate(-37.73 79.56) rotate(-8.7)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 314.62,
    y1: 148.75,
    x2: 231.05,
    y2: 419.03,
    gradientTransform: "translate(-90.35 186.12) rotate(-20.04)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 316.42,
    y1: 149.31,
    x2: 232.86,
    y2: 419.59,
    gradientTransform: "translate(-67.56 192.4) rotate(-20.04)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 302.67,
    y1: 186.98,
    x2: 219.1,
    y2: 457.26,
    gradientTransform: "translate(-37.73 79.56) rotate(-8.7)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 313.95,
    y1: 148.54,
    x2: 230.38,
    y2: 418.82,
    gradientTransform: "translate(67.49 -21.8) rotate(21.8)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 320.72,
    y1: 150.63,
    x2: 237.16,
    y2: 420.92,
    gradientTransform: "translate(202.84 -90.4) rotate(45.53)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 299.72,
    y1: 186.07,
    x2: 216.16,
    y2: 456.35,
    gradientTransform: "matrix(0.84, 0.55, -0.55, 0.84, 164.98, -85.98)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 306.24,
    y1: 188.08,
    x2: 222.68,
    y2: 458.36,
    gradientTransform: "translate(317.91 -109.93) rotate(56.86)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 303.04,
    y1: 187.09,
    x2: 219.47,
    y2: 457.37,
    gradientTransform: "translate(-37.73 79.56) rotate(-8.7)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 305.15,
    y1: 187.75,
    x2: 221.59,
    y2: 458.03,
    gradientTransform: "translate(-37.73 79.56) rotate(-8.7)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 320.16,
    y1: 150.46,
    x2: 236.59,
    y2: 420.74,
    gradientTransform: "translate(-67.56 192.4) rotate(-20.04)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 316.97,
    y1: 149.48,
    x2: 233.41,
    y2: 419.76,
    gradientTransform: "translate(-67.56 192.4) rotate(-20.04)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 306.41,
    y1: 188.13,
    x2: 222.84,
    y2: 458.41,
    gradientTransform: "translate(-37.73 79.56) rotate(-8.7)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 332.06,
    y1: 154.14,
    x2: 248.5,
    y2: 424.42,
    gradientTransform: "translate(-67.56 192.4) rotate(-20.04)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 318.21,
    y1: 149.86,
    x2: 234.64,
    y2: 420.14,
    gradientTransform: "translate(-67.56 192.4) rotate(-20.04)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 328.94,
    y1: 153.18,
    x2: 245.38,
    y2: 423.46,
    gradientTransform: "translate(-67.56 192.4) rotate(-20.04)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 307.8,
    y1: 146.64,
    x2: 224.23,
    y2: 416.92,
    gradientTransform: "translate(-67.56 192.4) rotate(-20.04)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 306.86,
    y1: 146.35,
    x2: 223.3,
    y2: 416.63,
    gradientTransform: "translate(-67.56 192.4) rotate(-20.04)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 315.59,
    y1: 149.05,
    x2: 232.02,
    y2: 419.33,
    gradientTransform: "translate(-67.56 192.4) rotate(-20.04)",
    xlinkHref: "#linear-gradient-2"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Alien 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M470.11,369c-28.87,20-65.08,31.45-87.82,58.92-2.51,3-5,5.91-7.48,8.66-16.59,18.3-33.95,30.4-61.84,33.29-19.58,2-39.2-2.47-58.36-6.89-17.67-4.07-34.85-10.71-52-17.49-29.39-11.62-58.6-23.62-89.73-23.62L58,374.89c-13.39-23.13-26.68-48.28-32.52-74.36S22.73,245,39.87,224.43c18.78-22.47,51.13-31,67.79-55,18.09-26.08,12.17-61.8,23.13-91.61,12.35-33.46,45.28-55.93,79.75-65S281.35,6,316.93,8.47c27.55,1.88,55.65,4,81.25,14.33C425,33.65,447.61,52.92,468.3,73.17c17.25,16.9,34.88,38.67,30.33,62.39-2.71,14.23-13.15,26-16.31,40.14-7.79,35.06,30,63.44,37.8,98.46C528.4,311.24,501.31,347.38,470.11,369Z",
    transform: "translate(-22.79 -6.28)",
    fill: "#008ffb",
    opacity: 0.48,
    style: {
      isolation: "isolate"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M374.81,436.62c-16.59,18.3-33.95,30.4-61.84,33.29-19.58,2-39.2-2.47-58.36-6.89-17.67-4.07-34.85-10.71-52-17.49l67.93-299.64,34.29-3.41Z",
    transform: "translate(-22.79 -6.28)",
    fill: "url(#linear-gradient)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 287.72,
    cy: 139.7,
    rx: 8.57,
    ry: 4.85,
    transform: "translate(-30.57 11.02) rotate(-3.4)",
    fill: "#008ffb"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 287.72,
    cy: 139.7,
    rx: 8.57,
    ry: 4.85,
    transform: "translate(-30.57 11.02) rotate(-3.4)",
    fill: "url(#linear-gradient-2)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M331.46,107.16A44.88,44.88,0,0,1,330.14,118a349.13,349.13,0,0,1-42.57,2.4,344.37,344.37,0,0,1-44.3-2.62,44.73,44.73,0,1,1,88.19-10.59Z",
    transform: "translate(-22.79 -6.28)",
    fill: "#008ffb"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M331.65,106.63v.48a11.74,11.74,0,0,1-10.77,11.56c-9.93.9-21.18,1.4-33.11,1.4-12.63,0-24.5-.57-34.84-1.56a11.82,11.82,0,0,1-10.5-9.35,10.76,10.76,0,0,1-.23-2.21v-.11a44.73,44.73,0,0,1,89.45-.21Z",
    transform: "translate(-22.79 -6.28)",
    fill: "url(#linear-gradient-3)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M331.65,106.63v.48a11.74,11.74,0,0,1-10.77,11.56c-6.85.62-14.33,1-22.22,1.25h0c-3.55.11-7.17.15-10.88.15-3.35,0-6.65,0-9.88-.12-8.95-.21-17.36-.72-25-1.44a11.82,11.82,0,0,1-10.5-9.35l-.23-2.32s11.53-6.39,43.53-6c0,0,0,0,0,0h.69c4.32.06,9,.25,14.06.61,8.66.58,18.45,1.61,29.48,3.27Z",
    transform: "translate(-22.79 -6.28)",
    fill: "#008ffb"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M331.65,106.63v.48a11.74,11.74,0,0,1-10.77,11.56c-6.85.62-14.33,1-22.22,1.25h0c-3.55.11-7.17.15-10.88.15-3.35,0-6.65,0-9.88-.12-8.95-.21-17.36-.72-25-1.44a11.82,11.82,0,0,1-10.5-9.35l-.23-2.32s11.53-6.39,43.53-6c0,0,0,0,0,0h.69c4.32.06,9,.25,14.06.61,8.66.58,18.45,1.61,29.48,3.27Z",
    transform: "translate(-22.79 -6.28)",
    fill: "url(#linear-gradient-4)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M303.27,98.11a12.75,12.75,0,0,1-2.26,2.78,5.57,5.57,0,0,0-.52.57c-.42.45-.82.91-1.19,1.39a7.31,7.31,0,0,0-.48.62,6.62,6.62,0,0,0-.46.62c-.2.29-.4.57-.58.86a.76.76,0,0,0-.08.11,4,4,0,0,0-.25.37,13,13,0,0,0-1.88,4.19,6.92,6.92,0,0,0-.14.77s0,.07,0,.09a4.93,4.93,0,0,0-.05.76,5.81,5.81,0,0,0,.72,2.86,8,8,0,0,0,.62.94c.22.3.45.59.65.92a7.52,7.52,0,0,1,.68,1.47,9.65,9.65,0,0,1,.3,1c.11.48.22,1,.31,1.44a.76.76,0,0,0,0,.16h0a.76.76,0,0,1,0-.16c-3.55.11-7.17.15-10.88.15-3.35,0-6.65,0-9.88-.12,0-.08.06-.15.08-.21a6.94,6.94,0,0,1,3-3c1.06-.55,2.24-.83,3.35-1.28a6,6,0,0,0,.73-.32,14.38,14.38,0,0,0,1.38-.78h0a12.42,12.42,0,0,0,1.41-1.1c.14-.13.29-.27.42-.41s.28-.29.41-.45a6.89,6.89,0,0,0,.69-1,5.29,5.29,0,0,0,.25-.54,5.38,5.38,0,0,0-.11-3.75c-.09-.25-.2-.5-.3-.74s-.24-.48-.37-.72-.27-.47-.41-.7-.28-.45-.41-.66h0l-.34-.52c-.64-1-1.27-1.93-1.91-2.87-.09-.15-.18-.28-.29-.43s0,0,0-.08c-.3-.45-.61-.9-.91-1.33a13.94,13.94,0,0,0-.89-1.11,20.84,20.84,0,0,1-1.37-1.59,5.48,5.48,0,0,1-.68-1.29,5.83,5.83,0,0,1-.22-.71,7.1,7.1,0,0,1-.18-2.25s0,0,0,0c0-.38.1-.75.16-1.12.05-.19.09-.37.15-.56a11.06,11.06,0,0,1,.9-2.13,16,16,0,0,1,2.3-3.12,16.37,16.37,0,0,1,2-1.94,10.3,10.3,0,0,1,1.16-.79,5.41,5.41,0,0,1,.63-.33l.63-.27c.51-.18,1-.34,1.43-.45a4.54,4.54,0,0,1,4.54,1.26l3.5,3.25c1.15,1.09,2.31,2.18,3.45,3.28.13.12.25.24.37.37a4,4,0,0,1,.94,1.26,2.08,2.08,0,0,1,.15.39,6.87,6.87,0,0,1,.21,1.27C304,94.33,304.13,96.37,303.27,98.11Z",
    transform: "translate(-22.79 -6.28)",
    fill: "#008ffb"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M303.27,98.11a12.75,12.75,0,0,1-2.26,2.78,5.57,5.57,0,0,0-.52.57c-.42.45-.82.91-1.19,1.39-.17.21-.33.41-.48.62s-.32.41-.46.62-.4.57-.58.86a.76.76,0,0,0-.08.11,4,4,0,0,0-.25.37,13,13,0,0,0-1.88,4.19c0,.18-.07.35-.11.52v0a1.62,1.62,0,0,0,0,.2s0,.07,0,.09a4.93,4.93,0,0,0-.05.76,5.81,5.81,0,0,0,.72,2.86,8,8,0,0,0,.62.94c.22.3.46.59.66.92a7.48,7.48,0,0,1,.67,1.47,9.65,9.65,0,0,1,.3,1c.11.48.21,1,.3,1.44-3.55.11-7.17.15-10.88.15-3.35,0-6.65,0-9.88-.12,0-.08.06-.15.08-.21a6.94,6.94,0,0,1,3-3c1.06-.55,2.24-.83,3.35-1.28a6,6,0,0,0,.73-.32,10.4,10.4,0,0,0,1.38-.78h0a11.38,11.38,0,0,0,1.41-1.1c.14-.13.29-.27.42-.41s.28-.29.41-.45a6.17,6.17,0,0,0,.69-1,5.29,5.29,0,0,0,.25-.54,5.38,5.38,0,0,0-.11-3.75c-.09-.25-.2-.5-.3-.74s-.24-.49-.37-.72-.27-.47-.41-.7-.28-.45-.41-.66h0l-.34-.52c-.64-1-1.27-1.93-1.91-2.87,0,0,0,0,0,0s-.19-.28-.28-.43,0,0,0-.08c-.3-.45-.61-.9-.91-1.33a13.94,13.94,0,0,0-.89-1.11,20.84,20.84,0,0,1-1.37-1.59,5.48,5.48,0,0,1-.68-1.29,7.33,7.33,0,0,1-.4-3s0,0,0,0c0-.38.1-.75.16-1.12.05-.19.09-.37.15-.56a9.46,9.46,0,0,1,.9-2.13,16,16,0,0,1,2.3-3.12,16.37,16.37,0,0,1,2-1.94,10.3,10.3,0,0,1,1.16-.79,5.41,5.41,0,0,1,.63-.33,5.78,5.78,0,0,1,.63-.28l.32-.1c.39-.13.76-.25,1.11-.34a4.54,4.54,0,0,1,4.54,1.26l3.5,3.25,3.45,3.27h0a3.23,3.23,0,0,1,.37.37,4,4,0,0,1,.94,1.26,2.08,2.08,0,0,1,.15.39,6.87,6.87,0,0,1,.21,1.27C304,94.33,304.13,96.37,303.27,98.11Z",
    transform: "translate(-22.79 -6.28)",
    fill: "url(#linear-gradient-5)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 287.59,
    cy: 94.66,
    rx: 3.25,
    ry: 4.07,
    transform: "translate(-27.77 166.32) rotate(-33.14)",
    fill: "#008ffb"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 300.28,
    cy: 94.78,
    rx: 4.07,
    ry: 2.71,
    transform: "translate(33.98 288.13) rotate(-56.86)",
    fill: "#008ffb"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 287.59,
    cy: 94.66,
    rx: 3.25,
    ry: 4.07,
    transform: "translate(-27.77 166.32) rotate(-33.14)",
    fill: "url(#linear-gradient-6)"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 300.28,
    cy: 94.78,
    rx: 4.07,
    ry: 2.71,
    transform: "translate(33.98 288.13) rotate(-56.86)",
    fill: "url(#linear-gradient-7)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M297.77,105l-.32.48a13.19,13.19,0,0,0-1.89,4.19,4.89,4.89,0,0,0-.09.53.06.06,0,0,1,0,0c-.36,1.87-.24,3.87-1.13,5.62a1.09,1.09,0,0,1-.64.62c-.56.15-1-.38-1.23-.86a14,14,0,0,1-.64-3.64,13.66,13.66,0,0,0-3.83-7.69l-.34-.53-2.19-3.29,0-.07c1.53.67,4.5,2.59,5,2.88,1.27.7,2.78,3.5,4.24,3.85C295.74,107.34,296.56,106.44,297.77,105Z",
    transform: "translate(-22.79 -6.28)",
    fill: "url(#linear-gradient-8)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M295.46,104a.62.62,0,0,0,.23,0,.71.71,0,0,0,.18-.08,2.85,2.85,0,0,1,1.45-.2.11.11,0,0,1,.08,0c.05.05,0,.13-.09.15a12.44,12.44,0,0,0-1.39.42,1,1,0,0,1-.44.22.83.83,0,0,1-.38-.07,2.56,2.56,0,0,0-1-.1,3.55,3.55,0,0,1-.8,0c-.06,0-.14-.05-.13-.12s.07-.08.13-.09A4.54,4.54,0,0,1,295.46,104Z",
    transform: "translate(-22.79 -6.28)",
    fill: "url(#linear-gradient-9)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M328.62,106.44v.24a10.58,10.58,0,0,1-9.7,10.39c-8.92.8-19.05,1.25-29.77,1.25-11.36,0-22-.5-31.34-1.39a10.58,10.58,0,0,1-9.64-10.4v-.09a40.23,40.23,0,1,1,80.45,0Z",
    transform: "translate(-22.79 -6.28)",
    opacity: 0.23,
    fill: "url(#linear-gradient-10)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M385.13,109.35c0-11.27-43.06-20.41-96.16-20.41s-96.17,9.14-96.17,20.41c0,1.05-.63,7.75.1,8.76,7,9.79,47.94,11.64,96.07,11.64,46.47,0,86.69-2.25,95.66-11.55C385.91,116.87,385.13,110.75,385.13,109.35Z",
    transform: "translate(-22.79 -6.28)",
    fill: "#008ffb"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M385.13,109.47c0-11.27-43.06-20.4-96.16-20.4s-96.17,9.13-96.17,20.4c0,.86-.61,7.4-.12,8.24,5.89,10.06,47.23,12.16,96.29,12.16,48.34,0,89-1.67,95.79-11.52C385.42,117.38,385.13,110.48,385.13,109.47Z",
    transform: "translate(-22.79 -6.28)",
    fill: "url(#linear-gradient-11)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M385.13,116.94c0,6.06-15.67,11.43-39.76,14.73A423.49,423.49,0,0,1,289,135.13a419.31,419.31,0,0,1-58.7-3.77c-22.78-3.33-37.46-8.54-37.46-14.42s14.52-11,37.11-14.35a417.8,417.8,0,0,1,59-3.83,425.71,425.71,0,0,1,56.76,3.5C369.62,105.57,385.13,110.92,385.13,116.94Z",
    transform: "translate(-22.79 -6.28)",
    fill: "#008ffb"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M370.47,117.08c0,3.91-13.65,7.38-34.63,9.51-13.8,1.41-30.77,2.23-49.12,2.23a493.37,493.37,0,0,1-51.11-2.43c-19.84-2.15-32.62-5.52-32.62-9.31s12.64-7.11,32.31-9.26a489,489,0,0,1,51.42-2.47c18.49,0,35.58.84,49.43,2.26C357,109.75,370.47,113.19,370.47,117.08Z",
    transform: "translate(-22.79 -6.28)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.19
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 228.58,
    cy: 125.2,
    rx: 4.27,
    ry: 7.56,
    transform: "translate(71.59 342.33) rotate(-87.72)",
    fill: "#008ffb"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 228.58,
    cy: 125.2,
    rx: 4.27,
    ry: 7.56,
    transform: "translate(71.59 342.33) rotate(-87.72)",
    fill: "url(#linear-gradient-12)"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 345.29,
    cy: 124.53,
    rx: 4.27,
    ry: 7.56,
    transform: "translate(184.33 458.31) rotate(-87.72)",
    fill: "#008ffb"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 345.29,
    cy: 124.53,
    rx: 4.27,
    ry: 7.56,
    transform: "translate(184.33 458.31) rotate(-87.72)",
    fill: "url(#linear-gradient-13)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M349.07,118.07v.31c0,5.91-2.61,11.48-7.23,16.31-10.12,10.58-29.74,17.77-52.28,17.77-22,0-41.21-6.85-51.51-17-5.11-5-8-10.85-8-17.08,0-.38,0-.77,0-1.11l5.25-.63a486.51,486.51,0,0,1,51.41-2.47c18.5,0,35.58.84,49.42,2.26C340.83,116.92,345.18,117.44,349.07,118.07Z",
    transform: "translate(-22.79 -6.28)",
    fill: "#008ffb"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M349.07,118.07v.31c0,5.91-2.61,11.48-7.23,16.31-10.12,10.58-29.74,17.77-52.28,17.77-22,0-41.21-6.85-51.51-17-5.11-5-8-10.85-8-17.08,0-.38,0-.77,0-1.11l5.25-.63a486.51,486.51,0,0,1,51.41-2.47c18.5,0,35.58.84,49.42,2.26C340.83,116.92,345.18,117.44,349.07,118.07Z",
    transform: "translate(-22.79 -6.28)",
    fill: "url(#linear-gradient-14)"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 235.3,
    cy: 107.82,
    rx: 7.79,
    ry: 4.41,
    transform: "translate(-24.88 -1.6) rotate(-1.13)",
    fill: "#008ffb"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 235.3,
    cy: 107.82,
    rx: 7.79,
    ry: 4.41,
    transform: "translate(-24.88 -1.6) rotate(-1.13)",
    fill: "url(#linear-gradient-15)"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 336.15,
    cy: 107.61,
    rx: 4.41,
    ry: 7.79,
    transform: "translate(190.32 432.14) rotate(-87.35)",
    fill: "#008ffb"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 336.15,
    cy: 107.61,
    rx: 4.41,
    ry: 7.79,
    transform: "translate(190.32 432.14) rotate(-87.35)",
    fill: "url(#linear-gradient-16)"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 283.92,
    cy: 105.92,
    rx: 7.79,
    ry: 4.41,
    transform: "translate(-24.84 -0.64) rotate(-1.13)",
    fill: "#008ffb"
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 283.92,
    cy: 105.92,
    rx: 7.79,
    ry: 4.41,
    transform: "translate(-24.84 -0.64) rotate(-1.13)",
    fill: "url(#linear-gradient-17)"
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 204.6,
    cy: 116.69,
    rx: 4.85,
    ry: 8.57,
    transform: "translate(57.07 310.21) rotate(-87.72)",
    fill: "#008ffb"
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 204.6,
    cy: 116.69,
    rx: 4.85,
    ry: 8.57,
    transform: "translate(57.07 310.21) rotate(-87.72)",
    fill: "url(#linear-gradient-18)"
  })), _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 370.43,
    cy: 117.34,
    rx: 4.85,
    ry: 8.57,
    transform: "translate(215.64 476.53) rotate(-87.72)",
    fill: "#008ffb"
  })), _ellipse20 || (_ellipse20 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 370.43,
    cy: 117.34,
    rx: 4.85,
    ry: 8.57,
    transform: "translate(215.64 476.53) rotate(-87.72)",
    fill: "url(#linear-gradient-19)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 257.23,
    cy: 256.87,
    r: 15.26,
    fill: "#008ffb",
    opacity: 0.36
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M276.89,258a7.64,7.64,0,0,0-1.33,3.18,4,4,0,0,0,.94,3.24,10.8,10.8,0,0,0,.89.76,13.19,13.19,0,0,1,1.24,1.24l1.49,1.64a9.45,9.45,0,0,1,1.32,1.7,3.08,3.08,0,0,1,.38,2.07,3.49,3.49,0,0,1-.59,1.21,6.45,6.45,0,0,1-2,1.79,18.75,18.75,0,0,0-1.75,1,3.88,3.88,0,0,0-1.4,1.95.35.35,0,0,0,0,.2c0,.14.22.17.37.17a31.23,31.23,0,0,0,11.16-1.94,6.59,6.59,0,0,0-1.08-2.17c-.27-.33-.6-.59-.86-.92a3.58,3.58,0,0,1-.68-2.44,7.7,7.7,0,0,1,.69-2.49,17,17,0,0,1,1.59-2.82,7,7,0,0,0,1-1.73,5.76,5.76,0,0,0-.23-3.2,2.91,2.91,0,0,0-.35-.9,3.1,3.1,0,0,0-.86-.79q-2.19-1.53-4.4-3a2.82,2.82,0,0,0-3.39.05A6.86,6.86,0,0,0,276.89,258Z",
    transform: "translate(-22.79 -6.28)",
    fill: "#008ffb"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M288.31,263.63a7.22,7.22,0,0,1-1,1.73,16.71,16.71,0,0,0-1.45,2.53c0,.09-.09.19-.14.29a7.7,7.7,0,0,0-.69,2.49c0,.09,0,.19,0,.29a0,0,0,0,1,0,0,3.44,3.44,0,0,0,.69,2.11c.26.34.59.6.87.93a6.77,6.77,0,0,1,1.07,2.17,31.45,31.45,0,0,1-11.16,1.94c-.15,0-.33,0-.37-.17s0-.13,0-.2a3.82,3.82,0,0,1,1.4-1.95,18.75,18.75,0,0,1,1.75-1,6.45,6.45,0,0,0,2-1.79,3.49,3.49,0,0,0,.59-1.21,3.08,3.08,0,0,0-.38-2.07,8,8,0,0,0-1.08-1.44l-.24-.26c-.5-.55-1-1.1-1.49-1.64,0,0,0,0,0,0a13.7,13.7,0,0,0-1.21-1.2,10.8,10.8,0,0,1-.89-.76,3.89,3.89,0,0,1-.93-3.24,7.49,7.49,0,0,1,1.32-3.18,7,7,0,0,1,2.19-2.23c1.24-.68,2.18-.87,3.39-.05q2.2,1.48,4.4,3a3,3,0,0,1,.86.8,2.76,2.76,0,0,1,.35.89A5.76,5.76,0,0,1,288.31,263.63Z",
    transform: "translate(-22.79 -6.28)",
    fill: "url(#linear-gradient-20)"
  })), _ellipse21 || (_ellipse21 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 279.32,
    cy: 263.05,
    rx: 1.82,
    ry: 2.28,
    transform: "translate(-127.03 247.1) rotate(-41.84)",
    fill: "#008ffb"
  })), _ellipse22 || (_ellipse22 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 286.37,
    cy: 262.03,
    rx: 2.28,
    ry: 1.52,
    transform: "translate(-93.45 408.07) rotate(-65.56)",
    fill: "#008ffb"
  })), _ellipse23 || (_ellipse23 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 279.32,
    cy: 263.05,
    rx: 1.82,
    ry: 2.28,
    transform: "translate(-127.03 247.1) rotate(-41.84)",
    fill: "url(#linear-gradient-21)"
  })), _ellipse24 || (_ellipse24 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 286.37,
    cy: 262.03,
    rx: 2.28,
    ry: 1.52,
    transform: "translate(-93.45 408.07) rotate(-65.56)",
    fill: "url(#linear-gradient-22)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M285.84,267.89c0,.09-.09.19-.14.29a7.7,7.7,0,0,0-.69,2.49c0,.09,0,.19,0,.29a0,0,0,0,1,0,0,11.12,11.12,0,0,1-.15,3.21.63.63,0,0,1-.3.4c-.29.13-.61-.12-.75-.37a7.49,7.49,0,0,1-.66-2,7.74,7.74,0,0,0-2.78-3.94l-.24-.26c-.5-.55-1-1.1-1.49-1.64,0,0,0,0,0,0,.9.25,2.71,1.06,3,1.18.76.28,1.84,1.7,2.68,1.77C284.92,269.38,285.3,268.82,285.84,267.89Z",
    transform: "translate(-22.79 -6.28)",
    fill: "url(#linear-gradient-23)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M284.48,267.53a.56.56,0,0,0,.13,0l.09-.06a1.62,1.62,0,0,1,.79-.23h0s0,.08,0,.1a5.6,5.6,0,0,0-.74.35.65.65,0,0,1-.22.16.55.55,0,0,1-.22,0,1.5,1.5,0,0,0-.56,0,2.15,2.15,0,0,1-.44.09s-.08,0-.08,0a.07.07,0,0,1,.06-.07A2.63,2.63,0,0,1,284.48,267.53Z",
    transform: "translate(-22.79 -6.28)",
    fill: "url(#linear-gradient-24)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M286.44,277a.32.32,0,0,1,.17.38",
    transform: "translate(-22.79 -6.28)",
    fill: "none"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M290.58,279.8a12.1,12.1,0,0,1,.49-4.73c.4-1,1.08-1.86,1.53-2.84a.39.39,0,0,0-.23-.65,17.19,17.19,0,0,0-17.15,3,8.1,8.1,0,0,0-1.59,1.77,1,1,0,0,0-.19.62c0,.3.31.52.57.69a36.46,36.46,0,0,0,3.42,2c4.19,6.59,5.27,14.66,7,22.29a2.43,2.43,0,0,0,.75,1.53,2.21,2.21,0,0,0,1.1.36,5.82,5.82,0,0,0,2,0c2.18-.5,3.5-2.85,3.66-5.09S290.62,282.2,290.58,279.8Z",
    transform: "translate(-22.79 -6.28)",
    fill: "#008ffb"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M292.6,272.23c-.44,1-1.13,1.85-1.53,2.84a12.12,12.12,0,0,0-.49,4.73c0,2.4,1.53,16.72,1.37,19a6.21,6.21,0,0,1-2,4.21,3.81,3.81,0,0,1-1.68.87,5.82,5.82,0,0,1-2,0,2.24,2.24,0,0,1-1.1-.36,2.49,2.49,0,0,1-.76-1.53c-1.69-7.63-2.77-15.7-7-22.29a35.83,35.83,0,0,1-3.43-2c-.25-.17-.53-.38-.56-.68a1,1,0,0,1,.19-.62,8.1,8.1,0,0,1,1.59-1.77,16.65,16.65,0,0,1,6.22-3.39h0a17.15,17.15,0,0,1,10.92.36.54.54,0,0,1,.28.19A.51.51,0,0,1,292.6,272.23Z",
    transform: "translate(-22.79 -6.28)",
    fill: "url(#linear-gradient-25)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M289,281.39a6.54,6.54,0,0,0,2.08,3.19,45.69,45.69,0,0,0,6.08,5,1.63,1.63,0,0,0,2.4.14,31.56,31.56,0,0,0,6.33-6.47,3.38,3.38,0,0,1,.78-.86,5.76,5.76,0,0,1,1.65-.57c.56-.17,1.13-.58,1.15-1.17,0-.77-.9-1.19-1.66-1.32a3.44,3.44,0,0,0-2.33.19,7.5,7.5,0,0,0-1.58,1.6,8.69,8.69,0,0,1-2.77,1.71c-1.39.63-1.83,2.54-3.28,2.06-2-.64-3.9-4.09-5.19-5.51-.62-.68-1.33-1.37-2.26-1A2.71,2.71,0,0,0,289,281.39Z",
    transform: "translate(-22.79 -6.28)",
    fill: "#008ffb"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M292.6,272.23c-.45,1-1.13,1.85-1.53,2.84a7.59,7.59,0,0,0-.47,2.2,10.84,10.84,0,0,0-3,.21c-1.73.18-3.45.38-5.17.57a12.7,12.7,0,0,0-2.76.52,36.32,36.32,0,0,1-3.13-1.86A1.11,1.11,0,0,1,276,276a.93.93,0,0,1,.2-.61,7.6,7.6,0,0,1,1.58-1.77,16.38,16.38,0,0,1,3.68-2.42h0a17.12,17.12,0,0,1,10.91.36.53.53,0,0,1,.29.19A.51.51,0,0,1,292.6,272.23Z",
    transform: "translate(-22.79 -6.28)",
    fill: "#008ffb"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M290.56,278.13c0,.56,0,1.12,0,1.67.07,4.75,1.08,7.34,1.44,12.07.14,1.95-.33,4.34,1.48,5.4s4.61,3.55,6.72,4.39a12.31,12.31,0,0,1,4.22,2.45,12.14,12.14,0,0,1,2.64,4.88,46.8,46.8,0,0,1,2,8.9c.23,1.84.46,3.9,1.91,5.05,1,.75,2.52,1.33,2.33,2.53a9.42,9.42,0,0,1-5.31.3,3.07,3.07,0,0,1-1.38-.63,3.75,3.75,0,0,1-.91-2.23A39.67,39.67,0,0,0,303.4,315a13,13,0,0,0-1.74-3.22c-2-2.58-5.39-3.63-8.54-4.54-2.3-.66-2.57.2-1.92,2.31.53,1.72,1.44,3.29,1.9,5,.82,3,.25,6.25,0,9.39s.06,6.58,2.17,8.92c.95,1.06,2.33,2,2.29,3.47a.89.89,0,0,1-.33.76,1.18,1.18,0,0,1-.85.07,17,17,0,0,1-4.86-1.71,7,7,0,0,1-3.34-3.19,6.66,6.66,0,0,1-.44-2.5c-.07-3.32,1-6.67.31-9.92-.6-3-2.56-5.52-4-8.23a10,10,0,0,1-1-8.08c1-2.85.61-5.3.41-8.26-.33-5.16-.26-10.74-2.89-15.38l8.95-1.45A2.29,2.29,0,0,0,290.56,278.13Z",
    transform: "translate(-22.79 -6.28)",
    fill: "#008ffb"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M274,258.6c-.11,1.52,0,3.2-.93,4.4-1.08,1.37-3.09,1.51-4.82,1.32a1.72,1.72,0,0,1-.59-.16,1.32,1.32,0,0,1-.52-.62c-1-2.05-.11-4.5,1-6.49a18.26,18.26,0,0,1,2.5-3.54c1.76-1.91,5-4.16,7.71-4-.2,1.31-2.06,2.65-2.74,3.85A12.58,12.58,0,0,0,274,258.6Z",
    transform: "translate(-22.79 -6.28)",
    fill: "#fff",
    opacity: 0.45
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M269.69,265.78a3.12,3.12,0,0,0-.95,3.34,5.32,5.32,0,0,0,.75,1.25,31.35,31.35,0,0,0,2.17,2.57,1.9,1.9,0,0,0,1,.67,1.49,1.49,0,0,0,1.38-.73c.32-.44.51-1,.85-1.4a7.67,7.67,0,0,0,.72-.9,2.49,2.49,0,0,0,.19-1.3C275.57,266.41,272.34,263.54,269.69,265.78Z",
    transform: "translate(-22.79 -6.28)",
    fill: "#fff",
    opacity: 0.45
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M274.92,287.59c-.33,2.78,1.41,5.48,3.7,7.09a23.68,23.68,0,0,0,7.77,3,2.29,2.29,0,0,0,1.24.08,2.07,2.07,0,0,0,.66-.38,5.49,5.49,0,0,0,1.43-1.37,1.82,1.82,0,0,0,.13-1.88,2.86,2.86,0,0,0-2-1,29.27,29.27,0,0,1-4.65-1.32,10.19,10.19,0,0,1-3.39-2.81c-1.18-1.68,2.84-3.32,3.41-5.29.64-2.14-.51-4.75-2.51-3.85A10.56,10.56,0,0,0,274.92,287.59Z",
    transform: "translate(-22.79 -6.28)",
    fill: "#008ffb"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 258.07,
    cy: 255.77,
    r: 15.26,
    opacity: 0.36,
    fill: "url(#linear-gradient-26)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M277.73,256.9a7.6,7.6,0,0,0-1.33,3.19,3.88,3.88,0,0,0,.93,3.23c.27.28.6.51.89.76a14.51,14.51,0,0,1,1.24,1.24L281,267a9,9,0,0,1,1.32,1.7,3.11,3.11,0,0,1,.38,2.08,3.37,3.37,0,0,1-.59,1.2,6.33,6.33,0,0,1-2,1.79,18.84,18.84,0,0,0-1.75,1,3.89,3.89,0,0,0-1.4,1.94.38.38,0,0,0,0,.21c.05.14.23.16.37.16a31.23,31.23,0,0,0,11.16-1.94,6.69,6.69,0,0,0-1.08-2.17c-.27-.32-.6-.59-.86-.92a3.58,3.58,0,0,1-.68-2.44,7.71,7.71,0,0,1,.69-2.48,17.1,17.1,0,0,1,1.59-2.83,6.73,6.73,0,0,0,1-1.73,5.72,5.72,0,0,0-.23-3.19,3.16,3.16,0,0,0-.34-.9,3.12,3.12,0,0,0-.87-.79c-1.46-1-2.92-2-4.4-3a2.82,2.82,0,0,0-3.38.06A6.64,6.64,0,0,0,277.73,256.9Z",
    transform: "translate(-22.79 -6.28)",
    fill: "url(#linear-gradient-27)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M289.14,262.53a6.73,6.73,0,0,1-1,1.73,16.71,16.71,0,0,0-1.45,2.53c-.05.1-.09.2-.13.29a7.6,7.6,0,0,0-.7,2.49v.33a3.46,3.46,0,0,0,.69,2.11c.26.33.59.6.87.92a6.87,6.87,0,0,1,1.07,2.17A31.23,31.23,0,0,1,277.3,277c-.14,0-.33,0-.37-.16a.38.38,0,0,1,0-.21,3.89,3.89,0,0,1,1.4-1.94c.54-.4,1.17-.65,1.75-1a6.33,6.33,0,0,0,2-1.79,3.45,3.45,0,0,0,.59-1.2,3.11,3.11,0,0,0-.38-2.08,8.33,8.33,0,0,0-1.08-1.44A2.85,2.85,0,0,1,281,267l-1.5-1.64,0,0a15.23,15.23,0,0,0-1.2-1.21,9.5,9.5,0,0,1-.9-.76,3.91,3.91,0,0,1-.93-3.23,7.66,7.66,0,0,1,1.32-3.19,6.83,6.83,0,0,1,2.19-2.22c1.25-.69,2.18-.88,3.39-.06,1.48,1,2.94,2,4.4,3a2.29,2.29,0,0,1,1.21,1.68A5.76,5.76,0,0,1,289.14,262.53Z",
    transform: "translate(-22.79 -6.28)",
    fill: "url(#linear-gradient-28)"
  })), _ellipse25 || (_ellipse25 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 280.15,
    cy: 261.95,
    rx: 1.82,
    ry: 2.28,
    transform: "translate(-126.09 247.38) rotate(-41.84)",
    fill: "url(#linear-gradient-29)"
  })), _ellipse26 || (_ellipse26 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 287.2,
    cy: 260.94,
    rx: 2.28,
    ry: 1.52,
    transform: "translate(-91.97 408.18) rotate(-65.56)",
    fill: "url(#linear-gradient-30)"
  })), _ellipse27 || (_ellipse27 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 280.15,
    cy: 261.95,
    rx: 1.82,
    ry: 2.28,
    transform: "translate(-126.09 247.38) rotate(-41.84)",
    fill: "url(#linear-gradient-31)"
  })), _ellipse28 || (_ellipse28 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 287.2,
    cy: 260.94,
    rx: 2.28,
    ry: 1.52,
    transform: "translate(-91.97 408.18) rotate(-65.56)",
    fill: "url(#linear-gradient-32)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M286.67,266.79c-.05.1-.09.2-.13.29a7.6,7.6,0,0,0-.7,2.49v.33a11.52,11.52,0,0,1-.14,3.21.65.65,0,0,1-.3.39c-.3.13-.62-.12-.76-.37a7.94,7.94,0,0,1-.66-2,7.77,7.77,0,0,0-2.78-3.95A2.85,2.85,0,0,1,281,267l-1.5-1.64,0,0c.9.24,2.71,1,3,1.17.76.28,1.84,1.7,2.68,1.78C285.75,268.29,286.13,267.72,286.67,266.79Z",
    transform: "translate(-22.79 -6.28)",
    fill: "url(#linear-gradient-33)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M285.31,266.43a.19.19,0,0,0,.13,0l.09-.05a1.53,1.53,0,0,1,.79-.24h.05s0,.07,0,.09c-.23.15-.53.18-.74.36s-.13.13-.22.15a.54.54,0,0,1-.22,0,1.52,1.52,0,0,0-.56,0,1.33,1.33,0,0,1-.44.09s-.08,0-.08-.05,0-.05.07-.06A2.57,2.57,0,0,1,285.31,266.43Z",
    transform: "translate(-22.79 -6.28)",
    fill: "url(#linear-gradient-34)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M287.27,275.87a.3.3,0,0,1,.17.37",
    transform: "translate(-22.79 -6.28)",
    fill: "url(#linear-gradient-35)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M291.41,278.7a12.26,12.26,0,0,1,.49-4.72c.4-1,1.09-1.87,1.53-2.85a.39.39,0,0,0-.23-.65,17.24,17.24,0,0,0-17.15,3,7.86,7.86,0,0,0-1.58,1.78.92.92,0,0,0-.2.61c0,.31.31.52.57.69a34.49,34.49,0,0,0,3.42,2c4.19,6.59,5.27,14.66,7,22.28a2.46,2.46,0,0,0,.75,1.54,2.35,2.35,0,0,0,1.11.36,6,6,0,0,0,2,0c2.18-.51,3.5-2.86,3.66-5.09S291.45,281.1,291.41,278.7Z",
    transform: "translate(-22.79 -6.28)",
    fill: "url(#linear-gradient-36)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M293.43,271.14c-.44,1-1.13,1.84-1.53,2.84a12.26,12.26,0,0,0-.49,4.72c0,2.4,1.53,16.73,1.37,19a6.2,6.2,0,0,1-2,4.21,3.82,3.82,0,0,1-1.69.88,6,6,0,0,1-2,0,2.25,2.25,0,0,1-1.11-.36,2.46,2.46,0,0,1-.75-1.54c-1.7-7.63-2.78-15.69-7-22.29a34.4,34.4,0,0,1-3.42-2c-.26-.17-.54-.38-.57-.69a1,1,0,0,1,.2-.62,8,8,0,0,1,1.58-1.77,16.57,16.57,0,0,1,6.22-3.38h0a17.08,17.08,0,0,1,10.92.35.51.51,0,0,1,.28.19A.53.53,0,0,1,293.43,271.14Z",
    transform: "translate(-22.79 -6.28)",
    fill: "url(#linear-gradient-37)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M289.82,280.29a6.48,6.48,0,0,0,2.08,3.2,44.38,44.38,0,0,0,6.08,5,2.14,2.14,0,0,0,1.69.54,2.05,2.05,0,0,0,.7-.4,31.06,31.06,0,0,0,6.33-6.47,3.56,3.56,0,0,1,.78-.86,5.85,5.85,0,0,1,1.65-.56c.56-.18,1.13-.59,1.15-1.17,0-.78-.9-1.19-1.66-1.33a3.5,3.5,0,0,0-2.33.19,7.55,7.55,0,0,0-1.58,1.61,8.62,8.62,0,0,1-2.77,1.7c-1.39.64-1.82,2.54-3.28,2.07-2-.64-3.9-4.1-5.19-5.51-.62-.69-1.33-1.38-2.26-1A2.72,2.72,0,0,0,289.82,280.29Z",
    transform: "translate(-22.79 -6.28)",
    fill: "url(#linear-gradient-38)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M293.43,271.14c-.45,1-1.13,1.84-1.53,2.84a7.52,7.52,0,0,0-.47,2.2,10.9,10.9,0,0,0-3,.2l-5.17.57a13.33,13.33,0,0,0-2.76.52,36.23,36.23,0,0,1-3.13-1.85,1.14,1.14,0,0,1-.57-.69,1,1,0,0,1,.2-.62,8.32,8.32,0,0,1,1.58-1.77,16,16,0,0,1,3.68-2.41h0a17.09,17.09,0,0,1,10.92.35.54.54,0,0,1,.28.19A.53.53,0,0,1,293.43,271.14Z",
    transform: "translate(-22.79 -6.28)",
    fill: "url(#linear-gradient-39)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M291.4,277c0,.55,0,1.12,0,1.67.08,4.74,1.09,7.33,1.44,12.07.15,1.94-.33,4.34,1.48,5.39s4.61,3.56,6.72,4.39a12.31,12.31,0,0,1,4.22,2.45,12.12,12.12,0,0,1,2.64,4.89,45.88,45.88,0,0,1,2,8.9c.23,1.83.46,3.9,1.91,5,1,.76,2.52,1.33,2.33,2.54a9.42,9.42,0,0,1-5.31.29,2.91,2.91,0,0,1-1.38-.63,3.79,3.79,0,0,1-.91-2.23,40.71,40.71,0,0,0-2.32-7.93,13.32,13.32,0,0,0-1.75-3.21c-2-2.58-5.39-3.63-8.54-4.54-2.3-.67-2.57.2-1.92,2.31.53,1.71,1.44,3.28,1.91,5,.81,3,.24,6.25,0,9.39s.07,6.59,2.17,8.93c.95,1.06,2.33,2,2.3,3.46a.93.93,0,0,1-.34.76,1.18,1.18,0,0,1-.85.07,17.16,17.16,0,0,1-4.86-1.71,7,7,0,0,1-3.34-3.19,6.77,6.77,0,0,1-.44-2.49c-.07-3.32,1-6.67.31-9.93-.6-3-2.55-5.51-4-8.23a10,10,0,0,1-1-8.08c1-2.85.61-5.3.42-8.26-.34-5.16-.27-10.74-2.9-15.37l8.95-1.46A2.37,2.37,0,0,0,291.4,277Z",
    transform: "translate(-22.79 -6.28)",
    fill: "url(#linear-gradient-40)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M274.8,257.51c-.11,1.52,0,3.2-.93,4.4-1.07,1.36-3.09,1.5-4.82,1.31a1.51,1.51,0,0,1-.59-.15,1.37,1.37,0,0,1-.52-.62c-1-2.05-.1-4.51,1-6.49a18.46,18.46,0,0,1,2.5-3.55c1.77-1.91,5-4.15,7.71-4-.2,1.31-2.06,2.64-2.74,3.84A12.63,12.63,0,0,0,274.8,257.51Z",
    transform: "translate(-22.79 -6.28)",
    opacity: 0.45,
    fill: "url(#linear-gradient-41)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M270.53,264.69a3.1,3.1,0,0,0-1,3.33,5.13,5.13,0,0,0,.75,1.25,31.5,31.5,0,0,0,2.17,2.58,2,2,0,0,0,1,.67,1.53,1.53,0,0,0,1.38-.73c.32-.45.51-1,.85-1.41a6.18,6.18,0,0,0,.72-.9,2.48,2.48,0,0,0,.19-1.3C276.4,265.31,273.17,262.44,270.53,264.69Z",
    transform: "translate(-22.79 -6.28)",
    opacity: 0.45,
    fill: "url(#linear-gradient-42)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M275.75,286.49c-.33,2.78,1.41,5.48,3.7,7.09a23.43,23.43,0,0,0,7.78,3,1.7,1.7,0,0,0,1.9-.3,5.26,5.26,0,0,0,1.42-1.36,1.83,1.83,0,0,0,.13-1.88,2.82,2.82,0,0,0-2-1,30.86,30.86,0,0,1-4.65-1.32,10,10,0,0,1-3.4-2.82c-1.18-1.67,2.84-3.31,3.42-5.28.63-2.15-.52-4.75-2.52-3.85A10.53,10.53,0,0,0,275.75,286.49Z",
    transform: "translate(-22.79 -6.28)",
    fill: "url(#linear-gradient-43)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlienNotFound);
export default __webpack_public_path__ + "static/media/alien_not_found.674edf2ca7cb10fa2c0edc9564b0032e.svg";
export { ForwardRef as ReactComponent };